module.exports = __webpack_public_path__ + "img/gilead.a59523ea.webp";